import { useMemo } from "react";
import { useAppSelector } from "@/store";
import { hr } from "@/constants/strings.hr";

export interface NavItem {
  label: string;
  path: string;
}

export function useNavItems(): NavItem[] {
  const categories = useAppSelector((s) => s.categories.items);

  return useMemo(
    () => [
      { label: hr.nav.home, path: "/" },
      ...categories.map((c) => ({
        label: c.name,
        path: `/kategorija/${c.name.toLowerCase()}`,
      })),
    ],
    [categories],
  );
}
